import React from 'react';


import {BasicPage} from 'src/components/basic-page';
import {CheckboxSkeleton, FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';

export const EditAlertSkeleton = () => (
    <BasicPage
        title="Edit Alert"
        buttonsBlock={(
            <Group>
                <SkeletonItem width={100} height={32}/>
                <SkeletonItem width={135} height={32}/>
                <SkeletonItem width={135} height={32}/>
            </Group>
        )}>
        <div className="pd-l">
            <Group direction="v" alignItems="start">
                <FormItemSkeleton labelWidth={62}>
                    <SkeletonItem width={624} height={312}/>
                </FormItemSkeleton>
                <CheckboxSkeleton labelWidth={75}/>
                <FormItemSkeleton labelWidth={62}>
                    <SkeletonItem width={300} height={32}/>
                </FormItemSkeleton>
                <FormItemSkeleton labelWidth={50}>
                    <SkeletonItem width={300} height={32}/>
                </FormItemSkeleton>
                <Group gap="l" alignItems="start">
                    <FormItemSkeleton labelWidth={200}>
                        <SkeletonItem width={300} height={32}/>
                    </FormItemSkeleton>
                    <FormItemSkeleton labelWidth={200}>
                        <SkeletonItem width={300} height={32}/>
                    </FormItemSkeleton>
                </Group>
                <Group gap="l" alignItems="start">
                    <FormItemSkeleton labelWidth={200}>
                        <SkeletonItem width={300} height={32}/>
                    </FormItemSkeleton>
                    <FormItemSkeleton labelWidth={200}>
                        <SkeletonItem width={300} height={32}/>
                    </FormItemSkeleton>
                </Group>
            </Group>
        </div>
    </BasicPage>
);
